import React from 'react'

import ActivateAccount from '../components/Auth/ActivateAccount/ActivateAccount'

const ActivateAccountPage = () => {
  return <ActivateAccount />
}

export default ActivateAccountPage
